import { Checkbox, FlexColumn, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { black } from "designSystem/styles/color";
import React, { FunctionComponent } from "react";

interface CheckboxWithHelperTextProps {
	/** when true the checkbox will be checked */
	isChecked: boolean;
	
	/* Indicates if the main text should be bolded */
	mainTextBold?: boolean;
	
	/* Indicates if the main text should be semiBolded */
	mainTextSemiBold?: boolean;

	/** onChange function to use with checkbox */
	onChange: (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;

	/** localization main resource to use to lookup text; can be simple resource or type resource (i.e. "User.Name") */
	res?: string;

	/** localization helper resource to use to lookup text; can be simple resource or type resource (i.e. "User.Name") */
	helperTextRes?: string;
}

const CheckboxWithHelperText: FunctionComponent<CheckboxWithHelperTextProps> = ((props) => {
	const {
		isChecked,
		mainTextBold = false,
		mainTextSemiBold = false,
		onChange,
		res,
		helperTextRes,
	} = props;
	
	const dataCsiAutomation= res ? `button-${res}` : undefined;
	const loc = useLocale();
	const mainText = loc.resource(res);
	const fontWeightInteger = mainTextBold ? 700 : mainTextSemiBold ?  600 : 400;
	const checkboxKey = `checkbox_with_helper_text_${Date.now()}_${Math.random()}`;
	return (
		<FlexColumn
			key={checkboxKey}
			style={{ cursor: "pointer" }}
			sx={{ padding: 1 }}
		>
			<Checkbox
				checked={isChecked}
				inputProps={{
					"data-csi-automation": dataCsiAutomation,
				} as React.InputHTMLAttributes<HTMLInputElement>}
				labelProps={{ label: mainText, sx: { fontWeight: fontWeightInteger } }}
				onChange={onChange}
			/>
			<Text
				color={black[500]}
				onClick={() => onChange({} as React.ChangeEvent<HTMLInputElement>, !isChecked)}
				res={helperTextRes}
				sx={{ paddingLeft: 8, marginTop: -1 }}
			/>
		</FlexColumn>
	);
});

export default CheckboxWithHelperText;